// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22xEE","left":"styles_left__192e0","desktopActions":"styles_desktopActions__2krGo","title":"styles_title__1serI"};